// const { doc } = require("prettier");

const oneTime = document.querySelector('[js-one-time-plan]');
const subscribe = document.querySelector('[js-subscription-plan]');
const details = document.querySelector('[js-subscribe-details]');
const select = document.querySelector('[js-subscription-widget-select]');
const discountedPriceEl = document.querySelector('[js-discounded-price]');
const compareAtPriceEl = document.querySelector('[js-compare-at-price]');


function toggleDetails() {
  
  if (subscribe.checked) {
    details.classList.add("subscription-widget__details--active");
    select.setAttribute("name", "selling_plan");
  } else {
    details.classList.remove("subscription-widget__details--active");
    select.removeAttribute("name");
  }


  updateAddToCartPrices();
}


function updateAddToCartPrices() {
  let newPrice = '';
  let comparePrice = '';
  const subscriptionDiscountedPriceEl = document.querySelector('[js-subscription-discounded-price]');
  const oneTimePriceEl = document.querySelector('[js-one-time-price]');
  

  if (subscribe.checked) {
    newPrice = subscriptionDiscountedPriceEl.textContent; 
    comparePrice = oneTimePriceEl.textContent;
  } else {
    newPrice = oneTimePriceEl.textContent;
    comparePrice = '';
  }

  console.log({newPrice})

  if (discountedPriceEl) {
    discountedPriceEl.textContent = newPrice;
  }

  if (compareAtPriceEl) {
    if (comparePrice) {
      compareAtPriceEl.textContent = comparePrice;
      compareAtPriceEl.style.display = "inline";
    } else {
      compareAtPriceEl.style.display = "none";
    }
  }
}

oneTime.addEventListener("change", toggleDetails);
subscribe.addEventListener("change", toggleDetails);

toggleDetails();